const getErrorApi = state => state.errorApi;

export default {
  getErrorApi,
};
